export * from './name.pipe';
